import React from "react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

export default function TermsOfUse() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <section className="pt-28 pb-20">
        <div className="max-w-3xl mx-auto px-6">
          <h1 className="text-4xl font-medium text-slate-900 mb-2" style={{ fontFamily: 'Outfit, sans-serif' }}>Terms of Use</h1>
          <p className="text-sm text-slate-400 mb-10">Last updated: January 2026</p>
          <div className="space-y-8 text-slate-700">
            <section>
              <h2 className="text-xl font-semibold text-slate-900 mb-3" style={{ fontFamily: 'Outfit, sans-serif' }}>1. Acceptance of Terms</h2>
              <p>By accessing or using the Apexum Partners platform, including AvA, you agree to these Terms of Use. If you do not agree, do not use the platform.</p>
            </section>
            <section>
              <h2 className="text-xl font-semibold text-slate-900 mb-3" style={{ fontFamily: 'Outfit, sans-serif' }}>2. Platform Purpose</h2>
              <p>The Apexum Partners platform is designed exclusively for qualified clinical organizations, licensed providers, clinic owners, and approved vendor partners. This platform is not intended for consumers or individuals seeking personal access to pharmaceutical or clinical products.</p>
            </section>
            <section>
              <h2 className="text-xl font-semibold text-slate-900 mb-3" style={{ fontFamily: 'Outfit, sans-serif' }}>3. No Medical Advice</h2>
              <p>Apexum Partners does not provide medical advice, diagnosis, or treatment recommendations. AvA is an AI-powered access connector — not a medical professional. All clinical decisions must be made by appropriately licensed healthcare providers.</p>
            </section>
            <section>
              <h2 className="text-xl font-semibold text-slate-900 mb-3" style={{ fontFamily: 'Outfit, sans-serif' }}>4. Compliance Requirements</h2>
              <p>All users of this platform agree that they are licensed clinical operators or their authorized representatives. Pharmacy, fulfillment, and vendor pathways accessed through Apexum are subject to qualification, partner review, applicable law, and current regulatory guidance.</p>
            </section>
            <section>
              <h2 className="text-xl font-semibold text-slate-900 mb-3" style={{ fontFamily: 'Outfit, sans-serif' }}>5. Limitation of Liability</h2>
              <p>Apexum Partners is a connector and routing platform. We make no guarantees regarding the availability, performance, or outcomes of any third-party pharmacy, lab, or fulfillment partner. Apexum's liability is limited to the extent permitted by applicable law.</p>
            </section>
            <section>
              <h2 className="text-xl font-semibold text-slate-900 mb-3" style={{ fontFamily: 'Outfit, sans-serif' }}>6. Modifications</h2>
              <p>We reserve the right to modify these Terms at any time. Continued use of the platform after changes are posted constitutes acceptance of the updated Terms.</p>
            </section>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
}
